const WorkerTaskStatusEnum = {
    1: "Çalışıyor",
    2: "Başarıyla Tamamlandı",
    3: "Hata ile Tamamlandı",
    '-1': "İptal Edildi",
};

export default WorkerTaskStatusEnum;